<!-- surface-profile -->
<div #container class="container" style="margin-top:0.5rem;" (click)="onClick()">

    <canvas id="steepnessChart" style="border: 2px solid goldenrod; min-height:300px;" aria-label="steepness-profile"
        role="img">
    </canvas>

</div>